import React from "react";
import { Select, MenuItem } from "@mui/material";
import i18n from "../i18n";
import { globalInputField } from "./constants";

const supportedLanguages = [
  "en",
  "hi",
  "ta",
  "te",
  "kn",
  "ml",
  "fr",
  "ru",
  "ba",
  "gu",
  "ma",
];

function LanguageDropdown() {
  const handleChange = (event) => {
    i18n.changeLanguage(event.target.value);
  };

  // Determine the initial value to select
  const selectedLanguage = supportedLanguages.includes(i18n.language)
    ? i18n.language
    : "en";

  return (
    <Select
      value={selectedLanguage}
      onChange={handleChange}
      displayEmpty
      size="small"
      inputProps={{ "aria-label": "Language Select" }}
      sx={{ color: "black", minWidth: 120, backgroundColor: globalInputField }} // Additional styles for visibility
    >
      <MenuItem value="en">English</MenuItem>
      <MenuItem value="hi">हिंदी</MenuItem>
      <MenuItem value="ta">தமிழ்</MenuItem>
      <MenuItem value="te">తెలుగు</MenuItem>
      <MenuItem value="kn">ಕನ್ನಡ</MenuItem>
      <MenuItem value="ml">മലയാളം</MenuItem>
      <MenuItem value="fr">Français</MenuItem>
      <MenuItem value="ru">Русский</MenuItem>
      <MenuItem value="ba">বাংলা</MenuItem>
      <MenuItem value="gu">ગુજરાતી</MenuItem>
      <MenuItem value="ma">मराठी</MenuItem>
    </Select>
  );
}

export default LanguageDropdown;
